import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BoxSeparator,
  ForbiddenSection,
  Page,
  TitleBox,
  ContentBox,
} from "../../../../../components";
import ROUTES from "../../../../../routes";
import { Language } from "../../../../../utils";
import { toTitleCase } from "../../../../../utils/Utils";
import { goBack } from "connected-react-router";
import makeClasses from "./styles";
import { Grid } from "@material-ui/core";
import { Policies } from "../../../../../utils/Policies";
import moment from "moment";

const ProvidersSubscriptionsIncompleteSubscriptionDetail = ({ location }) => {
  const dispatch = useDispatch();
  const classes = makeClasses();
  const subscription = location.state?.subscription || null;
  const [forbiddenSection, setForbbidenSection] = useState(false);
  const { policies, languageTexts } = useSelector((state) => ({
    policies: state.user.userData.policies || [],
    languageTexts: state.language.texts || {},
  }));
  const i18n = Language(languageTexts);
  const isForeignDocument = subscription?.subscriber?.country !== "URUGUAY";

  const STEP_VALUES = {
    PERSONAL_DATA: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Steps.PersonalData"
    ),
    PAYMENT: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Steps.Payment"
    ),
    PERSONAL_DATA_COMPLETED: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Steps.PersonalDataCompleted"
    ),
  };

  const REASON_VALUES = {
    POS_IS_INACTIVE: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.PosIsInactive"
    ),
    SUBSCRIPTION_DOES_NOT_EXIST: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.SubscriptionDoesNotExist"
    ),
    PURCHASE_FAILED_AT_PLEXO: getPLEXOErrorMessage(),
    PURCHASE_FAILED_AT_PLEXO_INSUFFICIENT_FUNDS: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.PurchaseFailedAtPlexoInsufficientFunds"
    ),
    SUBSCRIBER_DOES_NOT_EXIST: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.SubscriberDoesNotExist"
    ),
    SUBSCRIPTION_PLAN_DOES_NOT_EXIST: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.SubscriptionPlanDoesNotExist"
    ),
    SUBSCRIPTION_PLAN_INACTIVE: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.SubscriptionPlanInactive"
    ),
    SUBSCRIPTION_ALREADY_CANCELLED: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.SubscriptionAlreadyCancelled"
    ),
    BRANCH_DOES_NOT_EXIST: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.BranchDoesNotExist"
    ),
    BRANCH_DOES_NOT_HAVE_POS_BY_DEFAULT: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.BranchDoesNotHavePosByDefault"
    ),
    ERROR_DEACTIVATING_INSTRUMENT: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.ErrorDeactivatingInstrument"
    ),
    BRANCH_IS_NOT_ACTIVE: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.BranchIsNotActive"
    ),
    BRANCH_DONT_HAVE_TYC: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.BranchDontHaveTyc"
    ),
    SUBSCRIBER_ALREADY_HAS_SUBSCRIPTION_PLAN: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.SubscriberAlreadyHasSubscriptionPlan"
    ),
    ADDITIONAL_FIELD_DOES_NOT_EXIST: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.AdditionalFieldDoesNotExist"
    ),
    ADDITIONAL_FIELD_WRONG_TYPE: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.AdditionalFieldWrongType"
    ),
  };

  useEffect(() => {
    if (
      !policies ||
      !policies.includes(Policies.types.PROVIDERS_SUBSCRIPTIONS_SUBSCRIPTIONS)
    ) {
      setForbbidenSection(true);
    }
  }, [policies]);

  const handleOnGoBackClick = () => {
    dispatch(goBack());
  };

  function getPLEXOErrorMessage() {
    if (subscription.errorCode === 51 || subscription.errorCode === 3003) {
      return i18n.get(
        "ProvidersSubscriptionIncompleteSubscriptions.Reasons.PurchaseFailedAtPlexoInsufficientFunds"
      );
    }
    if (subscription.errorCode === 5 || subscription.errorCode === 3001) {
      return i18n.get(
        "ProvidersSubscriptionIncompleteSubscriptions.Reasons.PurchaseFailedAtPlexoCardDeclined"
      );
    }
    if (subscription.errorCode === -1) {
      return i18n.get(
        "ProvidersSubscriptionIncompleteSubscriptions.Reasons.PurchaseFailedAtPlexoPendingTransaction"
      );
    }
    return i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.PurchaseFailedAtPlexo"
    );
  }

  if (forbiddenSection) {
    return (
      <Page
        withHeader
        withSidebar
        withHeaderTitle={i18n.get(
          "ProvidersSubscriptionsManageSubscriptionDetails.Title"
        )}
        withActivePage={ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS.id}>
        <ForbiddenSection />
      </Page>
    );
  }

  return (
    <Page
      withHeader
      withSidebar
      withHeaderTitle={i18n.get(
        "ProvidersSubscriptionsIncompleteSubscriptionDetails.Title"
      )}
      withActivePage={ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS.id}>
      <TitleBox
        title={i18n.get(
          "ProvidersSubscriptionsIncompleteSubscriptionDetails.BoxTitle"
        )}
        back
        backTitle={i18n.get(
          "ProvidersSubscriptionsIncompleteSubscriptionDetails.BackButton"
        )}
        onBackClick={handleOnGoBackClick}
        backButtonVariant="outlined"
      />
      <BoxSeparator />
      {subscription ? (
        <React.Fragment>
          <ContentBox
            title={i18n.get(
              "ProvidersSubscriptionsIncompleteSubscriptionDetails.DetailsBoxLabel"
            )}>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsIncompleteSubscriptionDetails.DetailFields.Date"
                    )}
                    :
                  </div>
                  {subscription.createdAt
                    ? moment(subscription.createdAt).format(
                        `${i18n.get("DateFormat")} ${i18n.get("TimeFormat")}`
                      )
                    : "-"}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsIncompleteSubscriptionDetails.DetailFields.Plan"
                    )}
                    :
                  </div>
                  {subscription.subscriptionPlan
                    ? subscription.subscriptionPlan?.code
                      ? `${subscription.subscriptionPlan?.name} - ${subscription.subscriptionPlan?.code}`
                      : subscription.subscriptionPlan?.name
                    : "-"}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsIncompleteSubscriptionDetails.DetailFields.Branch"
                    )}
                    :
                  </div>
                  {subscription.branch ? subscription.branch?.name || "-" : "-"}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsIncompleteSubscriptionDetails.DetailFields.Step"
                    )}
                    :
                  </div>
                  {STEP_VALUES[subscription.attemptStep]}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsIncompleteSubscriptionDetails.DetailFields.Subscriber"
                    )}
                    :
                  </div>
                  {subscription.subscriber
                    ? `${subscription.subscriber?.document || "-"} - ${
                        subscription.subscriber?.firstName || "-"
                      } ${subscription.subscriber?.lastName || "-"}`
                    : "-"}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsIncompleteSubscriptionDetails.DetailFields.DocumentType"
                    )}
                    :
                  </div>
                  {i18n.get(
                    isForeignDocument
                      ? "ProvidersSubscriptionsIncompleteSubscriptionDetails.DetailFields.ForeignDocumentLabel"
                      : "ProvidersSubscriptionsIncompleteSubscriptionDetails.DetailFields.LocalDocumentLabel"
                  )}
                </div>
              </Grid>
              {isForeignDocument && (
                <Grid item xs={12} sm={12} md={3}>
                  <div className={classes.suscriptionDetailsItem}>
                    <div>
                      {i18n.get(
                        "ProvidersSubscriptionsIncompleteSubscriptionDetails.DetailFields.DocumentCountry"
                      )}
                    </div>
                    {toTitleCase(subscription.subscriber?.country)}
                  </div>
                </Grid>
              )}
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsIncompleteSubscriptionDetails.DetailFields.Email"
                    )}
                  </div>
                  {subscription.subscriber?.email || "-"}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsIncompleteSubscriptionDetails.DetailFields.Phone"
                    )}
                    :
                  </div>
                  {subscription.subscriber
                    ? `(${subscription.subscriber?.phoneCallingCode}) ${subscription.subscriber?.phoneNumber}`
                    : "-"}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsIncompleteSubscriptionDetails.DetailFields.Reason"
                    )}
                  </div>
                  {REASON_VALUES[subscription.failureReason]}
                </div>
              </Grid>
            </Grid>
          </ContentBox>
          {subscription?.additionalFields &&
          subscription?.additionalFields.length > 0 ? (
            <React.Fragment>
              <BoxSeparator size="small" />
              <ContentBox
                title={i18n.get(
                  "ProvidersSubscriptionsManageSubscriptionDetails.SubscriptionBoxAdditionalDataLabel"
                )}>
                {subscription?.additionalFields.map((field, key) => (
                  <Grid key={key} container spacing={4}>
                    <Grid item xs={12} sm={12} md={4}>
                      <div className={classes.suscriptionDetailsItem}>
                        <div>
                          {i18n.get(
                            "ProvidersSubscriptionsManageSubscriptionDetails.SubscriptionBoxAdditionalDataNameLabel"
                          )}
                          :
                        </div>
                        {field.name || "-"}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>
                      <div className={classes.suscriptionDetailsItem}>
                        <div>
                          {i18n.get(
                            "ProvidersSubscriptionsManageSubscriptionDetails.SubscriptionBoxAdditionalDataValueLabel"
                          )}
                          :
                        </div>
                        {field?.value || "-"}
                      </div>
                    </Grid>
                  </Grid>
                ))}
              </ContentBox>
            </React.Fragment>
          ) : null}
          <BoxSeparator size="small" />
        </React.Fragment>
      ) : null}
    </Page>
  );
};

ProvidersSubscriptionsIncompleteSubscriptionDetail.id =
  "com.Handy.ProvidersSubscriptionsIncompleteSubscriptionDetail";

export default ProvidersSubscriptionsIncompleteSubscriptionDetail;
